module.exports = __webpack_public_path__ + "img/truid.c8ead265.svg";